// Canonical record routes — every cross-module link should go through these.
const enc = (v) => encodeURIComponent(String(v));
export const quotePath = (idOrCode) => (idOrCode ? `/commercial/crm/quotations?open=${enc(idOrCode)}` : null);
export const newQuotePath = (customerId) => `/commercial/crm/quotations?new=1${customerId ? `&customer_id=${enc(customerId)}` : ""}`;
export const orderPath = (oid, tab, extra = {}) => {
  if (!oid || oid === "undefined" || oid === "null") return null;
  const q = new URLSearchParams({ ...(tab ? { tab } : {}), ...extra }).toString();
  return `/orders/${enc(oid)}${q ? `?${q}` : ""}`;
};
